export const  AHPMRIDS = ['urn:pearson:gps:productmodelregion:258009e1-960f-4e96-972c-21e6f2d15105','urn:pearson:gps:productmodelregion:efff9ce8-de08-459c-9ce2-d866b34ca45d','urn:pearson:gps:productmodelregion:e0fe76ad-bc5a-4dc1-8c7c-caf636e7e2a3','urn:pearson:gps:productmodelregion:9b92df41-f614-408a-8e49-d8a255a7b52a']

export const allowedActivehubHosts = [
    "homepage.pearson.com",
    "ggw-gb.pearson.com",
    "gateway.pearson.com",
    "stg-gb.ggw.ift.pearson-intl.com",
    "qa-gb.ggw.ift.pearson-intl.com",
    "dev-gb.ggw.ift.pearson-intl.com"
]